// src/pages/PreciosPage.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { listarPlanes } from '../services/api';
import PlanesCard from '../components/planes/PlanesCard';
import { useAuth } from '../context/AuthContext';

const PreciosPage = () => {
  const [planes, setPlanes] = useState({ unicos: [], suscripciones: [] });
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    cargarPlanes();
  }, []);

  const cargarPlanes = async () => {
    setLoading(true);
    try {
      const response = await listarPlanes();
      const todos = response.data.planes;
      
      setPlanes({
        unicos: todos.filter(p => p.tipo === 'unico'),
        suscripciones: todos.filter(p => p.tipo === 'suscripcion')
      });
    } catch (error) {
      console.error('Error cargando planes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSeleccionarPlan = (plan) => {
    if (!user) {
      navigate('/register', { state: { planSeleccionado: plan } });
    } else {
      // Aquí iría la lógica de compra/suscripción
      console.log('Plan seleccionado:', plan);
      // TODO: Integrar con pasarela de pagos
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Cargando planes...</p>
      </div>
    );
  }

  return (
    <div className="precios-container">
      <div className="precios-header">
        <h1>🌟 Elige tu camino como Creador</h1>
        <p className="subtitulo">
          Cada plan está diseñado para acompañarte en tu viaje por el multiverso
        </p>
      </div>

      {/* Planes de Suscripción Mensual */}
      <div className="seccion-planes">
        <h2>🔄 Suscripciones Mensuales</h2>
        <p className="seccion-desc">
          Para creadores que viven forjando universos día a día
        </p>
        <div className="planes-grid">
          {planes.suscripciones.map(plan => (
            <PlanesCard 
              key={plan.id} 
              plan={plan} 
              onSeleccionar={handleSeleccionarPlan}
              esAdmin={user?.rol === 'admin'}
            />
          ))}
        </div>
      </div>

      {/* Paquetes de Pago Único */}
      <div className="seccion-planes">
        <h2>📦 Paquetes de Pago Único</h2>
        <p className="seccion-desc">
          Para exploradores ocasionales que buscan aventuras esporádicas
        </p>
        <div className="planes-grid">
          {planes.unicos.map(plan => (
            <PlanesCard 
              key={plan.id} 
              plan={plan} 
              onSeleccionar={handleSeleccionarPlan}
              esAdmin={user?.rol === 'admin'}
            />
          ))}
        </div>
      </div>

      <div className="precios-footer">
        <p>✨ Todos los precios incluyen límites de imágenes para garantizar la mejor experiencia</p>
        <p className="small">Los Krums no utilizados se acumulan mes a mes en suscripciones activas</p>
      </div>
    </div>
  );
};

export default PreciosPage;